// src/firebaseConfig.js

// Your web app's Firebase configuration
// IMPORTANT: Replace these with your actual Firebase project configuration
const firebaseConfig = {
 apiKey: "AIzaSyBwb_06-f1w3aevSqHwjTqohLePIcvPWq4",
  authDomain: "ai-projects-250716.firebaseapp.com",
  projectId: "ai-projects-250716",
  storageBucket: "ai-projects-250716.firebasestorage.app",
  messagingSenderId: "872000338860",
  appId: "1:872000338860:web:f20befdf83dc3d45add809",
  measurementId: "G-FLRYG0LY87"
};

export default firebaseConfig;
